"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgExclamationCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.6 574.2V277.4c1.1-23.6 21.2-41.7 44.7-40.6 22 1.1 39.5 18.6 40.6 40.6v296.8c0 23.5-19.1 42.6-42.6 42.7-23.6 0-42.7-19.1-42.7-42.7zm44.4 98.7c-32.1 0-58.2 26.1-58.2 58.2s26.1 58.2 58.2 58.2 58.2-26.1 58.2-58.2-26.1-58.2-58.2-58.2zM1024 512c0 282.3-229.7 512-512 512S0 794.3 0 512 229.7 0 512 0s512 229.7 512 512zm-85.3 0c0-235.7-191.1-426.7-426.7-426.7S85.3 276.4 85.3 512 276.4 938.7 512 938.7s426.7-191 426.7-426.7z"
  }));
}

var ForwardRef = React.forwardRef(SvgExclamationCircle);
var _default = ForwardRef;
exports.default = _default;